import React, { Component } from "react";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import LoginPage from "./pages/Login";
import VinculosPage from "./pages/Vinculos";
import FinalizacaoCadastro from "./pages/FinalizacaoCadastro";
import CadastroPaciente from "./pages/CadastroPaciente";
import HomeIn from "./pages/HomeIn";
import NavBar from "./pages/navBar";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./index.css";
import GerenciamentoSistema from "./pages/GerenciamentoSistema";
import ListagemUsuarios from "./pages/ListagemUsuarios";
import Pacientes from "./pages/Pacientes";
import PrimeiraAvaliacao from "./pages/PrimeiraAvaliacao";
import Agendamentos from "./pages/Agendamentos";
import PrimeiraConsulta from "./pages/PrimeiraConsulta";
import NovoAgendamento from "./pages/NovoAgendamento";
import PerfilCompleto from "./pages/PerfilCompleto";
import Home from "./pages/home";
import PacienteLogin from "./pacientePages/pacienteLogin";
import PacienteCadastro from "./pacientePages/pacienteCadastro";
import Acessos from "./pages/Acessos";
import DadosPaciente from "./pages/DadosPaciente";
import ResumoConsulta from "./pages/ResumoConsulta";
import ProgressoMultidisciplinar from "./pages/ProgressoMultidisciplinar";
import ConsultaDemaisProfissionais from "./pages/ConsultaDemaisProfissionais";
import Escalas from "./pages/Escalas";
import EscalasPaciente from "./pages/EscalaPaciente";
import RegistrarEscala from "./pages/RegistrarEscala";
import RegistrarEscalaPaciente from "./pages/RegistrarEscalaPaciente";
import EvolucaoEscala from "./pages/EvolucaoEscala";
import DetalhesCadastro from "./pages/DetalhesCadastro";
import HomePaciente from "./pages/HomePaciente";
import GerenciamentoAcesso from "./pages/GerenciamentoAcesso";
import NotFound from "./pages/NotFound";
import EmailVerification from "./pages/EmailVerification";

// Modulo anjo

import MonitoramentoANJO from "./pages/MonitoramentoANJO";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#3E94C2",
    },
    background: {
      default: "#ffffff",
      text: {
        secondary: "#063F5E",
        primary: "#063F5E",
      },
    },
  },
  typography: {
    fontFamily: ["Nunito", "sans-serif"].join(","),
  },
});

class App extends Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <Router>
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/login" element={<LoginPage />} />
            {
              //<Route path="" element={<Navigate replace to="/login" />} />
            }
            <Route path="/homeOut" element={<Home />} />
            <Route path="/pacienteLogin" element={<PacienteLogin />} />

            <Route path="/cadastroPaciente" element={<PacienteCadastro />} />

            <Route element={<NavBar />}>
              <Route exact path="/vinculos" element={<VinculosPage />} />
              <Route exact path="/escalas/:id" element={<Escalas />} />
              <Route
                exact
                path="/escalas/registrar-escala/:id"
                element={<RegistrarEscala />}
              />
              <Route
                exact
                path="/consulta/registrar-escala/:id"
                element={<RegistrarEscala />}
              />
              <Route
                exact
                path="/escalas/evolucao/:id"
                element={<EvolucaoEscala />}
              />

              <Route exact path="/cadastro" element={<FinalizacaoCadastro />} />
              <Route exact path="/home" element={<HomeIn />} />
              <Route
                exact
                path="/cadastro-paciente"
                element={<CadastroPaciente />}
              />
              <Route
                path="/pacientes/consulta-demais-profissionais/:id"
                element={<ConsultaDemaisProfissionais />}
              />
              <Route exact path="/agendamentos" element={<Agendamentos />} />
              <Route
                path="/agendamentos/novo-agendamento"
                element={<NovoAgendamento />}
              />
              <Route exact path="/pacientes" element={<Pacientes />} />
              <Route
                path="/pacientes/prontuario/:id"
                element={<PerfilCompleto />}
              />

              <Route
                path="/pacientes/detalhes-cadastro/:id"
                element={<DetalhesCadastro />}
              />
              <Route
                path="/pacientes/resumo-consulta/:id"
                element={<ResumoConsulta />}
              />
              <Route
                path="/pacientes/primeira-avaliacao/:id"
                element={<PrimeiraAvaliacao />}
              />
              <Route
                path="/pacientes/dados-paciente/:id"
                element={<DadosPaciente />}
              />
              <Route
                path="/pacientes/primeira-consulta/:id"
                element={<PrimeiraConsulta />}
              />
              <Route
                path="/pacientes/consulta-rotina/:id"
                element={<PrimeiraConsulta />}
              />
              <Route
                path="/pacientes/progresso-multidisciplinar/:id"
                element={<ProgressoMultidisciplinar />}
              />

              <Route path="/pacientes/acessos/:id" element={<Acessos />} />
              <Route
                path="/gerenciamento-sistema"
                element={<GerenciamentoSistema />}
              />
              <Route
                path="/gerenciamento-sistema/gerenciamento-usuarios"
                element={<ListagemUsuarios />}
              />
              <Route path="/paciente/home" element={<HomePaciente />} />

              <Route
                path="/paciente/geracesso"
                element={<GerenciamentoAcesso />}
              />
              <Route
                path="/paciente/escalaspaciente"
                element={<EscalasPaciente />}
              />
              <Route
                exact
                path="/paciente/registrar-escala-paciente/:id"
                element={<RegistrarEscalaPaciente />}
              />
            </Route>
            <Route
              path="/confirmacao/email/:token"
              element={<EmailVerification />}
            />

            {/* MonitoramentoANJO */}
            <Route
              path="/paciente/monitoramento/anjo/:id"
              element={<MonitoramentoANJO />}
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </ThemeProvider>
    );
  }
}

export default App;
